import { Outlet } from 'react-router-dom';

import Footer from './Footer';
import Header from './Header';

export default function AppLayout() {
  return (
    <div className="flex min-h-screen" style={{ background: '#f5f0e8' }}>
      {/* Sidebar (desktop) / bottom bar (mobile) */}
      <Header />

      {/* Content column */}
      <div className="flex flex-col flex-1 min-w-0">
        <main id="main-content" className="grow pb-16 md:pb-0">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
